import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { IdType } from "../../Utils/IdType";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";
import OpeningTime, { OpeningTimeDto } from "../../OpeningTimes/OpeningTime";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";

export const useFetchPlantOpeningTimes = (parentId: IdType) => {
  return useQuery<OpeningTime[], Error>({
    queryKey: openingTimeWithIdQueryKey(parentId, "odcs"),
    queryFn: () => fetchOpeningTimesForPlant(parentId),
    onError: () => {
      toast.error(
        `An error occurred when retrieving opening times for the plant with Id ${parentId}`
      );
    },
  });
};

const fetchOpeningTimesForPlant = async (parentId: IdType) => {
  const { data: openingTimesDtos } = await axios.get<OpeningTimeDto[]>(
    openingTimesUrls.openingTimesForPlantsWithId(parentId)
  );

  return OpeningTimeMapper.toOpeningTimes(openingTimesDtos);
};
